import { createSlice, createSelector } from '@reduxjs/toolkit';
import { SnsImLoadDirection } from '@web-sns-im';
const initialState = {};
const initialDirection = {
    [SnsImLoadDirection.NEWER]: false,
    [SnsImLoadDirection.EARLIER]: false,
};
const initialApp = {
    filter: null,
    unreadCount: 0,
    chatId: null,
    chatList: [],
    chatIniting: false,
    chatHasMore: Object.assign({}, initialDirection),
    chatLoading: Object.assign({}, initialDirection),
    chatContentMap: {},
};
const snsImSlicer = createSlice({
    name: 'snsImSlicer',
    initialState,
    reducers: {
        init: (state, action) => {
            const { appId } = action.payload;
            state[appId] = Object.assign({}, initialApp);
        },
        destory: (state, action) => {
            const { appId } = action.payload;
            const app = state[appId];
            if (app) {
                delete state[appId];
            }
        },
        update: (state, action) => {
            const { appId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                state[appId] = Object.assign(Object.assign({}, app), payload);
            }
        },
        updateChatHasMore: (state, action) => {
            const { appId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                state[appId].chatHasMore = Object.assign(Object.assign({}, state[appId].chatHasMore), payload);
            }
        },
        updateChatLoading: (state, action) => {
            const { appId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                state[appId].chatLoading = Object.assign(Object.assign({}, state[appId].chatLoading), payload);
            }
        },
        updateChat: (state, action) => {
            const { appId, chatId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                state[appId].chatList = state[appId].chatList.map(item => {
                    if (item.chatId !== chatId)
                        return item;
                    return Object.assign(Object.assign({}, item), payload);
                });
            }
        },
        insertChat: (state, action) => {
            const { appId, chatList, chatSorter } = action.payload;
            const app = state[appId];
            if (app) {
                const chatListMap = [...state[appId].chatList, ...chatList].reduce((accumulator, chat) => {
                    if (!accumulator[chat.chatId] || accumulator[chat.chatId].chatTime <= chat.chatTime) {
                        accumulator[chat.chatId] = chat;
                    }
                    return accumulator;
                }, {});
                state[appId].chatList = Object.values(chatListMap).sort(chatSorter);
            }
        },
        updateChatContent: (state, action) => {
            const { appId, chatId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                const chatContent = state[appId].chatContentMap[chatId];
                if (chatContent) {
                    state[appId].chatContentMap = Object.assign(Object.assign({}, state[appId].chatContentMap), { [chatId]: Object.assign(Object.assign({}, state[appId].chatContentMap[chatId]), payload) });
                }
            }
        },
        updateChatContentMap: (state, action) => {
            const { appId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                state[appId].chatContentMap = Object.assign(Object.assign({}, state[appId].chatContentMap), payload);
            }
        },
        updateMessageHasMore: (state, action) => {
            const { appId, chatId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                const chatContent = state[appId].chatContentMap[chatId];
                if (chatContent) {
                    state[appId].chatContentMap[chatId].messageHasMore = Object.assign(Object.assign({}, state[appId].chatContentMap[chatId].messageHasMore), payload);
                }
            }
        },
        updateMessageLoading: (state, action) => {
            const { appId, chatId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                const chatContent = state[appId].chatContentMap[chatId];
                if (chatContent) {
                    state[appId].chatContentMap[chatId].messageLoading = Object.assign(Object.assign({}, state[appId].chatContentMap[chatId].messageLoading), payload);
                }
            }
        },
        insertMessage: (state, action) => {
            const { appId, chatId, direction, messageList } = action.payload;
            const app = state[appId];
            if (app) {
                const chatContent = state[appId].chatContentMap[chatId];
                if (chatContent) {
                    if (direction === SnsImLoadDirection.EARLIER) {
                        state[appId].chatContentMap[chatId].messageList = [...messageList, ...state[appId].chatContentMap[chatId].messageList];
                    }
                    if (direction === SnsImLoadDirection.NEWER) {
                        state[appId].chatContentMap[chatId].messageList = [...state[appId].chatContentMap[chatId].messageList, ...messageList];
                    }
                }
            }
        },
        updateMessage: (state, action) => {
            const { appId, chatId, messageId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                const chatContent = state[appId].chatContentMap[chatId];
                if (chatContent) {
                    const { messageList } = chatContent;
                    const hasUpdatedFromServer = messageList.some(item => item.messageId === payload.messageId);
                    if (!hasUpdatedFromServer) {
                        state[appId].chatContentMap[chatId].messageList = state[appId].chatContentMap[chatId].messageList.map(item => {
                            if (item.messageId !== messageId)
                                return item;
                            return Object.assign(Object.assign({}, item), payload);
                        });
                    }
                }
            }
        },
        updateMessageFile: (state, action) => {
            const { appId, chatId, messageId, payload } = action.payload;
            const app = state[appId];
            if (app) {
                const chatContent = state[appId].chatContentMap[chatId];
                if (chatContent) {
                    state[appId].chatContentMap[chatId].messageList = state[appId].chatContentMap[chatId].messageList.map(item => {
                        if (item.messageId !== messageId)
                            return item;
                        if (!item.messageFile)
                            return item;
                        return Object.assign(Object.assign({}, item), { messageFile: Object.assign(Object.assign({}, item.messageFile), payload) });
                    });
                }
            }
        },
    },
    extraReducers(builder) {
        builder;
    },
});
export const getApp = createSelector((state, appId) => {
    return state[appId] || null;
}, (app) => app);
export const { actions } = snsImSlicer;
export default snsImSlicer.reducer;
